import { render, staticRenderFns } from "./MatiVerificacion.vue?vue&type=template&id=0ea03f61&"
import script from "./MatiVerificacion.vue?vue&type=script&lang=js&"
export * from "./MatiVerificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QExpansionItem,QSeparator,QItem,QItemSection,QIcon,QItemLabel,QBtn,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QExpansionItem,QSeparator,QItem,QItemSection,QIcon,QItemLabel,QBtn,QCard,QCardSection})
